const NoTextLayout = () =>
`
  <Toggle />
`;

const ExceptionLayout = () =>
`
  <Toggle greenBg />
`;

const WithTextLayout = () =>
`
  <Toggle label="label" withSideLabel />
`;

const togglesTemplates = {
  noText: NoTextLayout(),
  exception: ExceptionLayout(),
  withText: WithTextLayout()
};

export default togglesTemplates;



// WEBPACK FOOTER //
// ./src/containers/elements/Toggles/constants/togglesTemplates.js